import { render } from "./sel-youtube-video.vue?vue&type=template&id=52e7d5d8"
import script from "./sel-youtube-video.vue?vue&type=script&lang=js"
export * from "./sel-youtube-video.vue?vue&type=script&lang=js"

import "./sel-youtube-video.vue?vue&type=style&index=0&id=52e7d5d8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__